var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "batchEditGoods-container",
      attrs: { "element-loading-text": "保存中" }
    },
    [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "table-box" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%", "margin-bottom": "20px" },
              attrs: {
                data: _vm.selectSpuList,
                "row-key": "goodsId",
                border: "",
                "tree-props": {
                  children: "children",
                  hasChildren: "hasChildren"
                }
              }
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", width: "1" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [scope.row.isSpu ? void 0 : _vm._e()]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "商品名称", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.isSpu
                          ? [
                              _c("el-input", {
                                attrs: { size: "mini" },
                                model: {
                                  value: scope.row.name,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "name", $$v)
                                  },
                                  expression: "scope.row.name"
                                }
                              })
                            ]
                          : [_c("span", [_vm._v(_vm._s(scope.row.name))])]
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function() {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "dark",
                              content: "只对商品第一张图片进行管理",
                              placement: "top"
                            }
                          },
                          [_c("i", { staticClass: "el-icon-info" })]
                        ),
                        _vm._v("\n           商品图片\n        ")
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v("\n           \n          "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.previewPicClick(scope.row.picUrl)
                              }
                            }
                          },
                          [_vm._v("预览")]
                        ),
                        _vm._v("    \n          "),
                        _c(
                          "el-upload",
                          {
                            attrs: {
                              action:
                                _vm.env.VUE_APP_fileserver + "persistentUpload",
                              "show-file-list": false,
                              "on-success": function(res) {
                                return _vm.uploadSuccess(res, scope.row)
                              },
                              "before-upload": _vm.pictureBeforeUpload
                            }
                          },
                          [
                            _c(
                              "el-button",
                              { attrs: { size: "mini", type: "text" } },
                              [_vm._v("更换")]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "价格(元)", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.isSpu
                          ? [_vm._v("——")]
                          : [
                              _c("el-input", {
                                attrs: { type: "number", size: "mini" },
                                model: {
                                  value: scope.row.marketPriceStr,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "marketPriceStr", $$v)
                                  },
                                  expression: "scope.row.marketPriceStr"
                                }
                              })
                            ]
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "单位", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.isSpu
                          ? [_vm._v("——")]
                          : [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    size: "mini",
                                    filterable: "",
                                    placeholder: "请选择"
                                  },
                                  on: { change: _vm.unitSelectChange },
                                  model: {
                                    value: scope.row.mUnit,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "mUnit", $$v)
                                    },
                                    expression: "scope.row.mUnit"
                                  }
                                },
                                _vm._l(scope.row.unitList, function(unitItem) {
                                  return _c("el-option", {
                                    key: unitItem.unitsCode,
                                    attrs: {
                                      label: unitItem.unitsName,
                                      value: unitItem.unitsCode
                                    }
                                  })
                                }),
                                1
                              )
                            ]
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "库存", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.isSpu
                          ? [_vm._v("——")]
                          : [
                              _c("el-input", {
                                attrs: { type: "number", size: "mini" },
                                model: {
                                  value: scope.row.currQuantity,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "currQuantity", $$v)
                                  },
                                  expression: "scope.row.currQuantity"
                                }
                              })
                            ]
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "分类", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.isSpu
                          ? [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    size: "small",
                                    placeholder: "选择分类"
                                  },
                                  on: { change: _vm.shopDecorateIdChange },
                                  model: {
                                    value: scope.row.shopDecorateId,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "shopDecorateId", $$v)
                                    },
                                    expression: "scope.row.shopDecorateId"
                                  }
                                },
                                _vm._l(_vm.customCateList, function(cateItem) {
                                  return _c("el-option", {
                                    key: cateItem.shopDecorateId,
                                    attrs: {
                                      label: cateItem.name,
                                      value: cateItem.shopDecorateId
                                    }
                                  })
                                }),
                                1
                              )
                            ]
                          : [_vm._v("——")]
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function() {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "dark",
                              content:
                                "启用后，该商品只支持微信支付，您将承担千分之六的手续费",
                              placement: "top"
                            }
                          },
                          [_c("i", { staticClass: "el-icon-info" })]
                        ),
                        _vm._v("\n           微信支付\n        ")
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.isSpu
                          ? [
                              _c("el-switch", {
                                attrs: {
                                  "active-color": "#1890ff",
                                  "active-value": 1,
                                  "inactive-value": 0
                                },
                                model: {
                                  value: scope.row.isAssumeWxFee,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "isAssumeWxFee", $$v)
                                  },
                                  expression: "scope.row.isAssumeWxFee"
                                }
                              })
                            ]
                          : void 0
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function() {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "dark",
                              content:
                                "启用后，该商品支持银行卡支付，您将承担(储蓄卡千分之三/信用卡千分之六)的手续费",
                              placement: "top"
                            }
                          },
                          [_c("i", { staticClass: "el-icon-info" })]
                        ),
                        _vm._v("\n           银行卡支付\n        ")
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.isSpu
                          ? [
                              _c("el-switch", {
                                attrs: {
                                  "active-color": "#1890ff",
                                  "active-value": 1,
                                  "inactive-value": 0
                                },
                                model: {
                                  value: scope.row.isAssumeCloudFee,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "isAssumeCloudFee", $$v)
                                  },
                                  expression: "scope.row.isAssumeCloudFee"
                                }
                              })
                            ]
                          : void 0
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "配送模板", width: "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.isSpu
                          ? [
                              _c(
                                "el-select",
                                {
                                  on: { change: _vm.deliveryTemplateIdChange },
                                  model: {
                                    value: scope.row.deliveryTemplateId,
                                    callback: function($$v) {
                                      _vm.$set(
                                        scope.row,
                                        "deliveryTemplateId",
                                        $$v
                                      )
                                    },
                                    expression: "scope.row.deliveryTemplateId"
                                  }
                                },
                                _vm._l(_vm.deliveryTemplateList, function(
                                  deliveryModel
                                ) {
                                  return _c("el-option", {
                                    key: deliveryModel.id,
                                    attrs: {
                                      label: deliveryModel.name,
                                      value: deliveryModel.id
                                    }
                                  })
                                }),
                                1
                              )
                            ]
                          : void 0
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "运费模板", width: "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.isSpu
                          ? [
                              _c(
                                "el-select",
                                {
                                  on: {
                                    change: _vm.shopFreightTemplateIdChange
                                  },
                                  model: {
                                    value: scope.row.shopFreightTemplateId,
                                    callback: function($$v) {
                                      _vm.$set(
                                        scope.row,
                                        "shopFreightTemplateId",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "scope.row.shopFreightTemplateId"
                                  }
                                },
                                _vm._l(_vm.freightFormworkList, function(
                                  freightModel
                                ) {
                                  return _c("el-option", {
                                    key: freightModel.id,
                                    attrs: {
                                      label: freightModel.name,
                                      value: freightModel.id
                                    }
                                  })
                                }),
                                1
                              )
                            ]
                          : void 0
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "bottom-box" },
        [
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "center" } },
            [
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: { click: _vm.cancelBtnClick }
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.sureBtnClick }
                    },
                    [_vm._v("确定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.showPreviewImg, width: "290px" },
          on: {
            "update:visible": function($event) {
              _vm.showPreviewImg = $event
            }
          }
        },
        [
          _c("el-image", {
            staticStyle: { width: "250px", height: "250px" },
            attrs: { src: _vm.previewImgSrc, fit: "cover" }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "提示", visible: _vm.showSaveDialog, width: "300px" },
          on: {
            "update:visible": function($event) {
              _vm.showSaveDialog = $event
            }
          }
        },
        [
          _c("span", [_vm._v("您确定要保存当前设置吗？")]),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.showSaveDialog = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.saveSureBtnClick }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("h2", [_vm._v("商品管理 / 批量编辑")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }